__webpack_require__.p = "/modules/custom/lsp_react_block/app/build/";